// components
import navbar from './components/navbar';
// gsap
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

// register ScrollTrigger & ScrollSmoother
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);

// get window width & height
let windowWidth = window.screen.width;
let windowHeight = window.screen.height;

// init ScrollSmoother
let smoother;
if(windowWidth >= 576) {
    let smoother = ScrollSmoother.create({
        smooth: 1,     // how long (in seconds) it takes to "catch up" to the native scroll position
        effects: true,   // looks for data-speed and data-lag attributes on elements
        ignoreMobileResize: true,
    });
}

// preloader
function preLoader() {
    const preloader = document.querySelector('.preloader');
    const preloaderOrange = document.querySelector('.preloader__orange');
    const preloaderGreen = document.querySelector('.preloader__green');
    const preloaderWhite = document.querySelector('.preloader__white');
    const preloaderLogo = document.querySelector('.preloader__logo');

    let preloaderTl = gsap.timeline({ease: "ease"});
    preloaderTl.to(preloaderOrange, {
        x: "-90%",
        y: "40%",
        duration: 2
    })
    .to(preloaderGreen, {
        x: "50%",
        y: "-40%",
        duration: 2,
        onStart: () => {
            setTimeout(() => {
                preloaderLogo.classList.remove('logo-animate');
            }, "500");
        }
    }, "-=2")
    .to(preloaderLogo, {
        scale: 1.2,
        autoAlpha: 0,
        duration: 1.2,
    }, "-=1.2")
    .to(preloaderWhite, {
        autoAlpha: 0,
        duration: 1.2,
        onComplete: () => {
            preloader.remove();
        }
    }, "-=0.7")
}

// fade up animation on scroll
function fadeUpOnScroll() {
    const fadeUpEl = document.querySelectorAll('.fade-up');
    fadeUpEl.forEach((item) => {
        gsap.fromTo(item, {
            y: 100,
            autoAlpha: 0,
        }, {
            y: 0,
            autoAlpha: 1,
            duration: 0.8,
            ease: "ease",
            scrollTrigger: {
                trigger: item,
                start: "top-=100 bottom-=20%",
                // markers: true,
            },
        })
    })
}

// scale big to normal
function scaleInOnScroll() {
    const scaleInEl = document.querySelectorAll('.scale-in');
    scaleInEl.forEach((item) => {
        const scaleItemParent = item.parentNode;
        gsap.fromTo(item, {
            scale: 1.4,
        }, {
            scale: 1,
            duration: 0.8,
            ease: "ease",
            scrollTrigger: {
                trigger: scaleItemParent,
                start: "top-=100px bottom-=15%",
                // markers: true,
            },
        })
    })
}

// line section on scroll
function lineOnScroll() {
    const lineSection = document.querySelector('.line');
    const lineTrigger = document.querySelector('.line-trigger');

    if (windowWidth >= 576) {
        gsap.fromTo(lineSection, {
            right: "-35%",
        }, {
            right: "0",
            duration: 0.6,
            ease: "ease",
            scrollTrigger: {
                trigger: lineTrigger,
                start: "bottom center-=100",
                scrub: true,
                // markers: true
            },
        })
    }
}

// scroll to section from home button
function scrollByUrl() {
    const informationPage = document.querySelector('.information');
    const queryUrl = window.location.href; // GET QUERY URL
    let urlString = new URL(queryUrl);
    let sectionIdParam = urlString.searchParams.get("section_id");

    if (sectionIdParam) {
        setTimeout(() => {
            if(informationPage) {
                gsap.to(window, { duration: 0.4, scrollTo: { y: `#${sectionIdParam}`, offsetY: 120 } });
            } else {
                gsap.to(window, { duration: 0.4, scrollTo: `#${sectionIdParam}` });
            }
        }, 2500);
    }
}

// ========== enabel & disable scrolling - https://stackoverflow.com/questions/4770025/how-to-disable-scrolling-temporarily ==========
// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
var keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefault(e) {
  e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
}

// modern Chrome requires { passive: false } when adding event
var supportsPassive = false;
try {
  window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
    get: function () { supportsPassive = true; } 
  }));
} catch(e) {}

var wheelOpt = supportsPassive ? { passive: false } : false;
var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
// call this to Disable
function disableScroll() {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
}
// call this to Enable
function enableScroll() {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt); 
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
}
disableScroll();

window.addEventListener('load', function(){
    preLoader();

    // show scroll after preloader hide
    setTimeout(() => {
        enableScroll();
    }, "1800");
})

document.addEventListener("DOMContentLoaded", function () {
    scrollByUrl();
    fadeUpOnScroll();
    scaleInOnScroll();
    lineOnScroll();
})

// export
export { gsap, ScrollTrigger, ScrollSmoother, smoother };
export { windowWidth, windowHeight };